/* @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { Button, VisuallyHidden } from '@coursera/cds-core';
import { AddIcon, RemoveIcon } from '@coursera/cds-icons';

import { follow, unfollow } from 'bundles/discussions/actions/ThreadDetailsActions';

import _t from 'i18n!nls/discussions';

import type { ForumPostWithCreator } from '../forumsV2-ForumThreads/__providers__/ForumPostDataProvider/__types__';

type Props = {
  question: ForumPostWithCreator;
};

class FollowButton extends React.Component<Props> {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof FollowButton.contextTypes>;

  toggleFollowing = () => {
    const { question } = this.props;

    if (question.isFollowing) {
      this.context.executeAction(unfollow, { question });
    } else {
      this.context.executeAction(follow, { question });
    }
  };

  render() {
    const { isFollowing, followError } = this.props.question;

    const errorLabel = _t('Sorry, something went wrong');
    const followingLabel = isFollowing ? _t('Unfollow this post') : _t('Follow this post');
    const label = followError ? errorLabel : followingLabel;

    return (
      <React.Fragment>
        <VisuallyHidden aria-live="polite" component="span" className="rc-A11yScreenReaderOnly">
          {label}
        </VisuallyHidden>
        <Button
          variant="ghost"
          size="small"
          type="button"
          className="rc-forumsV2_FollowButton"
          onClick={this.toggleFollowing}
          icon={isFollowing ? <RemoveIcon size="small" /> : <AddIcon size="small" />}
          iconPosition="before"
        >
          {label}
        </Button>
      </React.Fragment>
    );
  }
}

export default FollowButton;
